import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionExpiredService {
  readonly isRefreshing$ = new BehaviorSubject<boolean>(false);

  private sessionExpired$$ = new Subject<void>();
  readonly sessionExpired$ = this.sessionExpired$$.asObservable();

  trigger(): void {
    this.sessionExpired$$.next();
  }
}
